import React, { FC } from 'react';
import { FormControlLabel, Grid, Switch } from '@material-ui/core';
import { useFormikContext, FieldArray } from 'formik';
import { useTranslation } from 'react-i18next';

import { ContentInput } from 'api';
import { useCurrentUser } from 'hooks';

import { isOnlyModerator } from '../../helpers';
import { usePostContext } from '../../PostContext';

import GroupDropdown from './GroupDropdown';

const GroupSelection: FC = () => {
  const currentUser = useCurrentUser();
  const { values, setFieldValue } = useFormikContext<ContentInput>();
  const { t } = useTranslation();
  const { state, dispatch } = usePostContext();

  const { group_ids } = values;
  const hasModeratorToggle = isOnlyModerator(currentUser);

  function handleToggleModeratorMode() {
    setFieldValue('group_ids', []);
    dispatch({ type: 'moderatorMode' });
  }

  return (
    <Grid item container alignItems="center" justify="space-between">
      <Grid item xs={5}>
        <FieldArray name="group_ids">
          {helpers => <GroupDropdown selectedIds={group_ids} helpers={helpers} />}
        </FieldArray>
      </Grid>
      {hasModeratorToggle && (
        <Grid item>
          <FormControlLabel
            value={state.moderatorMode}
            control={
              <Switch
                checked={state.moderatorMode}
                color="primary"
                onChange={handleToggleModeratorMode}
              />
            }
            label={t('posting:moderatorMode')}
            labelPlacement="start"
          />
        </Grid>
      )}
    </Grid>
  );
};

export default GroupSelection;
